import React, { Dispatch, SetStateAction } from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

interface CheckboxProps {
	label: string;
	setIsChecked: Dispatch<SetStateAction<boolean>>;
	checked: boolean;
}

const ArchiveCheckbox: React.FC<CheckboxProps> = ({ label, setIsChecked, checked }) => {

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setIsChecked(event.target.checked);
	};

	return (
		<FormControlLabel
			control={
				<Checkbox
					checked={checked}
					onChange={handleChange}
					sx={{
						color: '#eb0029',
						'&.Mui-checked': {
							color: '#eb0029',
						},
						'& .MuiSvgIcon-root': {
							borderRadius: '4px',
						},
					}}
				/>
			}
			label={label}
			sx={{
				'& .MuiFormControlLabel-label': {
					fontSize: '16px',
					fontFamily: 'sans-serif',
					color: '#333',
				},
			}}
		/>
	);
};

export default ArchiveCheckbox;